export default {
  errors: {
    COMMON: 'Terjadi Kesalahan',
    NOT_FOUND: 'Tidak Ditemukan',
    NO_INTERNET: 'Tidak ada koneksi internet',
    INTERNAL_SERVER_ERROR: 'Internal Server Error',
    EMAIL_NOT_REGISTERED: 'Email belum terdaftar, silahkan hubungi admin',
    EMAIL_ALREADY_USED: 'Email sudah digunakan, silahkan gunakan yang lain',
    NO_ACCESS: 'Anda tidak punya akses untuk membuka halaman ini',
  },
  validation: {
    NAME: 'Format nama yang digunakan salah, tidak boleh menggunakan . / ; [ ] -',
    EMAIL: 'Format email yang digunakan salah',
    PHONE_NUMBER: 'Format no telp yang digunakan salah',
    LICENSE_NUMBER: 'Format no sim yang diguanakn salah, hanya berupa angka',
    PASSWORD: 'Silahkan masukkan password anda',
    PASSWORD_AGAIN: 'Silahkan masukkan kembali kata sandi anda',
    PASSWORD_NOT_MATCH: 'Kata sandi tidak cocok!',
    PASSWORD_NOT_SIX: 'Panjang kata sandi harus minimal 6 karakter',
    IMAGE_TOO_LARGE: 'Ukuran gambar tidak boleh lebih dari 500kb.',
    USERNAME: 'Silahkan masukkan nama Anda',
    REQUIRED: (field) => `${field} wajib diisi`,
    EMPTY: 'Beberapa kolom harus diisi',
    LICENSE_PLATE: 'Format nomor kendaraan salah',
  },
};
